import { Box } from 'rebass'
import styled from 'styled-components'

import { Help } from '../shared/Help'
import { PageHeader } from '../shared/PageHeader'
import { ProcessFlow } from '../shared/stepper/processFlowIndicator'
import { ButtonContainer,Card, CardHeader, SecondaryButton } from '../shared/styledComponents'
import { UploadForm } from './UploadForm'
import { UploadNotifications } from './UploadNotifications'

const SubmitFileBody = styled.div`
  padding-left: 0px;
  padding-bottom: 24px;
  padding-right: 24px;
`

const SubmitFileTexts = styled.li`
  font-family: NeueHaasUnica, sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
  color: #333333;
`
const claimHeader = 'How do I upload files?'

const claimHelp = <SubmitFileBody>
  <ul>
    <SubmitFileTexts>
      Travelers supports most file types for photos, videos and documents.
    </SubmitFileTexts>
    <SubmitFileTexts>
      Select the category from the drop down list that <b>best describes</b> the file(s) you are
      uploading. You may select more than one category based on the file types you are submitting.
    </SubmitFileTexts>
    <SubmitFileTexts>
      Search your device and add files by clicking the “Select files” button. You can edit items
      until you’re ready to submit them.
    </SubmitFileTexts>
    <SubmitFileTexts>
      There is a size limit of 30MB per upload (not applicable to videos). If your total items
      exceed 30MB, you will be able to create additional submissions.
    </SubmitFileTexts>
    <SubmitFileTexts>
      Once you click the &quot;Submit&quot; button, you will see a progress bar showing your upload
      in process. You will receive a notification when your upload is successfully completed.
    </SubmitFileTexts>
    <SubmitFileTexts>Connect to Wi-Fi for faster uploads.</SubmitFileTexts>
  </ul>
</SubmitFileBody>

type UploadContainerProps = {
  clickBackButton(): void
  requesting: boolean
}

const UploadContainer = ({ clickBackButton, requesting }: UploadContainerProps) => (
  <Box width={[1, 15.6 / 16]} >
    <UploadNotifications />
    <PageHeader />
    <ProcessFlow active="upload" />
    <Card>
      <CardHeader>Uploads</CardHeader>
      <Help
        source="uploads"
        claimHeader={claimHeader}
        claimHelp={claimHelp}
        pageName="upload-help"
      />

      <UploadForm requesting={requesting} />
    </Card>
    <ButtonContainer>
      <SecondaryButton onClick={clickBackButton} float="left" disabled={requesting}>
        Back
      </SecondaryButton>
    </ButtonContainer>
  </Box>
)

export { UploadContainer }
